// components/KenButton.tsx
import React, { Children } from "react";
import { Button, ButtonProps } from "@mui/material";

interface KenButtonProps extends ButtonProps {
  label?: string;
  variant?: "primary" | "secondary" | "danger" | "outlined";
  style?: React.CSSProperties; // allow style prop
  children?:any
}

const KenButton: React.FC<KenButtonProps> = ({
  label,
  variant = "primary",
  style,
  children,
  ...props
}) => {
  return (
    <Button
      style={{ textTransform: "capitalize", ...style }} // merge custom styles
      variant={variant as any}
      {...props}
    >
      {label}
      {children}
    </Button>
  );
};

export default KenButton;
